import { render, staticRenderFns } from "./LevelCard.vue?vue&type=template&id=0f546d58&"
import script from "./LevelCard.vue?vue&type=script&lang=js&"
export * from "./LevelCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports